export { default } from './TimeComponent';
